import React, { useState } from 'react';
import Modal from 'components/UI/DialogModal';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { ISelectedEmployeesForInvitation } from 'models/workshopInvitations';
import { CircularProgress, Grid, IconButton, Stack, TableCell, Tooltip, Typography } from '@mui/material';
import { DualListBox } from 'components/UI/DualList';
import useFetchSection from 'hooks/useFetchSection';
import { getInvitations, getUninvitedEmployeesAsync } from 'framework/workshopInvitations';
import { DualGroupsListBox } from 'components/UI/DualList/groups';
import List from 'components/UI/List';
import { AttendedListCells, AttendedListGroupCells } from 'framework/workshops';
import { Feature } from 'models/api';
import DeleteWorkshopsGroupInvitation from '../DeleteWorkshopsGroupInvitation/DeleteWorkshopsGroupInvitation';
import { Delete } from '@mui/icons-material';
import { handleError } from 'helpers/utils';
import { useAlert } from 'contexts/alertContext';
import { useMutation } from 'react-query';
import { deleteWorkshopsGroup, deleteWorkshopsGroupInvitation } from 'framework/workshopsGroups';

interface Props {
  open: boolean;
  id:string;
  feature: Feature;
  onClose: () => void;
}

const ShowInvitations: React.FC<Props> = ({ open,feature,  id, onClose }) => {

  const { t ,i18n} = useTranslation()
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>('');
  const { setAlert } = useAlert();
  const [loading2, setLoading2] = useState<boolean>(false);


  const deleteWorkshopsGroupMutation = useMutation({
    mutationFn: (code: string) => {
      return deleteWorkshopsGroupInvitation(code);
    },
  });

  const {
    loading,
    data: Table,
  } = useFetchSection({
    fetchData: () => getInvitations(`?workshopId=${id}`),
    fetchPermission: () => null!,
    section: "Invitation Table",
  });



  const handleOpenDelete = (invitation: any) => {
    setSelectedId(invitation.id);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setLoading2(false);
    setSelectedId('');
  };


  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteWorkshopsGroupMutation.mutateAsync(selectedId);
      setAlert({
        open: true,
        message: "Workshop Group Invitation deleted successfully",
        type: "success",
      });
      
      handleCloseDelete();
      onClose()
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

if(loading) return null



  const getAttendedBodyCells = (row: {employeeName:string,employeeEmail:string,departmentName:string}) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "employeeName")
        return {
          id: "employeeName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.employeeName}</Typography>
            </TableCell>
          ),
        };
      if (key === "employeeEmail")
        return {
          id: "employeeEmail",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.employeeEmail}</Typography>
            </TableCell>
          ),
        };

      if (key === "departmentName")
        return {
          id: "departmentName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.departmentName}</Typography>
            </TableCell>
          ),
        };

        if (key === "id")
          return {
            id: "actions",
            element: (
              <TableCell align={"left"} key={i}>
                <Stack
                  direction={"row"}
                  alignContent={"center"}
                  spacing={1}
                  justifyContent={i18n.language === "en" ? "start" : "end"}
                >
                
  
                
                    <Tooltip title={t("T_delete")}>
                      <IconButton
                        size={"small"}
                        sx={{
                          color : "red",
                          "&:hover": "red",
                        }}
                        onClick={() => handleOpenDelete(row)}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                </Stack>
              </TableCell>
            ),
          };

      else return <></>;
    });

    return cells;
  };



  if( loading) return null
 
  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_workshop_invitations_list')}
      maxWidth="lg"
      fullScreen
      children={<div style={{padding:10,marginBlock:20}} >
       
        <List
              headCells={AttendedListGroupCells}
              data={Table!}
              getBodyCells={getAttendedBodyCells}
              feature={feature}
              canEdit={false}
            />
            {openDelete && (
        <DeleteWorkshopsGroupInvitation
          open={openDelete}
          loading={loading2}
          onClose={handleCloseDelete}
          onSubmit={handleDelete}
        />
      )}
      </div>}
      actions={null}
    />
  </>
  );
};

export default ShowInvitations;
